export default function DSA_Counting_Sort_Time() {
  return <div>DSA_Counting_Sort_Time Component</div>;
}
